import { render, staticRenderFns } from "./DialogModal.vue?vue&type=template&id=595a0ebc&scoped=true"
import script from "./DialogModal.vue?vue&type=script&lang=js"
export * from "./DialogModal.vue?vue&type=script&lang=js"
import style0 from "./DialogModal.vue?vue&type=style&index=0&id=595a0ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595a0ebc",
  null
  
)

export default component.exports